import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from './auth.service';
import { TwoFactorSetupModalService } from './two-factor-setup-modal.service';

const BLOCK_MESSAGE_KEY = 'security.guard.modal.message';

export const twoFactorSetupGuard: CanActivateChildFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const modalService = inject(TwoFactorSetupModalService);

  const urlWithoutQuery = state.url.split('?')[0] ?? '';
  const isSecurityRoute = urlWithoutQuery.endsWith('/security');

  if (isSecurityRoute) {
    return true;
  }

  return authService.getTwoFactorStatus().pipe(
    map((status) => {
      const mustSetup = status.required && !status.enabled;
      if (!mustSetup) {
        return true;
      }

      const preferredSlug = authService.getPreferredCompanySlug();
      modalService.open(BLOCK_MESSAGE_KEY);
      if (preferredSlug) {
        return router.createUrlTree(['/', preferredSlug, 'security']);
      }

      return router.createUrlTree(['/security']);
    }),
    catchError(() => of(true)),
  );
};
